import { styled, Tooltip } from '@mui/material'
import { SpotOrderStatus } from 'api/v1/spot'
import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'

const StatusText = styled('span')``
const Pending = styled(StatusText)`
  color: ${(props) => props.theme.color.notificationYellow02};
`
const Filled = styled(StatusText)`
  color: rgba(14, 203, 129, 1);
`
const PartialFilled = styled(StatusText)`
  color: ${(props) => props.theme.color.notificationPurple02};
`
const Cancelled = styled(StatusText)`
  color: ${(props) => props.theme.color.text40};
`
const Failed = styled(StatusText)`
  color: ${(props) => props.theme.color.notificationRed02};
`

export const OrderStatus: FC<{
  status: SpotOrderStatus
}> = memo(({ status }) => {
  const { t } = useTranslation()

  if (status === SpotOrderStatus.FULLY_FILLED) {
    return <Filled>{t('user-order-table-content-status-filled')}</Filled>
  } else if (status === SpotOrderStatus.PARTIAL_FILLED) {
    return (
      <Tooltip arrow placement="top" title={`${t('ioc-cancelled-info')}`}>
        <PartialFilled>Partial Filled</PartialFilled>
      </Tooltip>
    )
  } else if (status === SpotOrderStatus.FULLY_CANCELLED) {
    return <Cancelled>Cancelled</Cancelled>
  } else if (status === SpotOrderStatus.PARTIAL_CANCELLED) {
    return <Cancelled>Partial Cancelled</Cancelled>
  } else if (status === SpotOrderStatus.FAILED) {
    return <Failed>Failed</Failed>
  } else if (status === SpotOrderStatus.PENDING) {
    return <Pending>{SpotOrderStatus.PENDING}</Pending>
  }
  return null
})
